import React from 'react';
import { SocialButton, SocialButtonsContainer } from './components';
import {
  FacebookLogo,
  PinterestLogo,
  LinkedinLogo,
  TwitterLogo
} from '../../../images/icons/social';

type SocialLinksProps = {
  title: string;
  href: string;
  imageUrl: string | undefined;
};

const getBlogUrl = (href: string) => {
  const siteUrl = `https://${process.env.GATSBY_WWW}/learn/`;
  return encodeURIComponent(siteUrl + href);
};

const SocialLinks = ({ href, title, imageUrl }: SocialLinksProps) => {
  const blogUrl = getBlogUrl(href);

  const social = [
    {
      ariaLabel: 'Facebook',
      icon: <FacebookLogo />,
      href: `https://www.facebook.com/sharer/sharer.php?u=${blogUrl}`
    },
    {
      ariaLabel: 'Twitter',
      icon: <TwitterLogo />,
      href: `https://twitter.com/intent/tweet?url=${blogUrl}`
    },
    {
      ariaLabel: 'Linkedin',
      icon: <LinkedinLogo />,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${blogUrl}`
    },
    {
      ariaLabel: 'Pinterest',
      icon: <PinterestLogo />,
      href: `http://pinterest.com/pin/create/button/?url=${blogUrl}&media=${imageUrl}&description=${title}`
    }
  ];
  return (
    <SocialButtonsContainer>
      {social.map(({ ariaLabel, icon, href }, index) => {
        const props = {
          href: href ? href : '#',
          'aria-label': ariaLabel,
          target: '_blank'
        };

        return (
          <SocialButton {...props} key={index}>
            {icon}
          </SocialButton>
        );
      })}
    </SocialButtonsContainer>
  );
};

export default SocialLinks;
